import React from "react";
import "./DropdownNavbarMenu.scss";
import RegularIconText from "../../Atoms/RegularIconText/RegularIconText";
import { Link } from "wouter";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";

const DropdownNavbarMenu = ({ content }) => {
	const {language} = useLanguageCtx();

	return (
		<div
			className={`dropdownNavbarMenu--container`}
		>
			{content &&
				content.map((content, index) => (
					<Link href={content.to} key={index}>
						<div className="dropdownNavbarMenu--link-container all-width flex center-content-items">
							<RegularIconText
								icon={content.icon}
								text={content[language].text}
								boldText={content[language].boldText}
								width="100%"
								inNavbar
							/>
						</div>
					</Link>
				))}
		</div>
	);
};

export default DropdownNavbarMenu;
